"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Models a logging event.
 * @constructor
 * @param {String} name - name of logger
 * @param {Level} level - level of message (INFO, ERROR...)
 */
var LoggingEvent = function LoggingEvent(name, level) {
	_classCallCheck(this, LoggingEvent);

	/**
  * the timestamp of the Logging Event
  * @type Date
  * @private
  */
	this.dateLogged = new Date();
	/**
  * loggerName of event
  * @type String
  * @private
  */
	this.name = name;
	/**
  * level of log
  * @type Level
  * @private
  */
	this.level = level;
};

exports.default = LoggingEvent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-kenny-loggins/lib/loggingEvent.js
// module id = 759
// module chunks = 0